import script from "./OnboardingAiFlow.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiFlow.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiFlow.vue?vue&type=style&index=0&id=6aa7fc8c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa7fc8c"]])

export default __exports__